export enum EUserPaymentQueryKey {
  PAYMENT_INITIATE_DEPOSIT_FIAT = 'payment-initiate-deposit-fiat',
  GET_AVAILABLE_CRYPTO_CONTRACTS = 'get-available-crypto-contracts',
  INITIATE_CRYPTO_DEPOSIT_INPUT = 'initiate-crypto-deposit-input',
  PAYMENT_VERIFY_DEPOSIT_FIAT = 'payment-verify-deposit-fiat',
  CALCULATE_DEPOSIT_COST = 'calculate-deposit-cost',
  CALCULATE_WITHDRAWAL_COST = 'calculate-withdrawal-cost',
  GET_FIAT_TRANSACTION_HISTORY = 'get-fiat-transaction-history',
  INITIATE_WITHDRAW_FIAT = 'initiate-withdraw-fiat',
}
